import React from 'react'
import { IconButton } from '@astryxdesign/core/IconButton'
import { HStack } from '@astryxdesign/core/Layout'
import { Pencil } from 'lucide-react'

interface ChapterHeadingProps {
  title: string
  subtitle: string
  onEdit: () => void
}

export default function ChapterHeading({
  title,
  subtitle,
  onEdit
}: ChapterHeadingProps): React.JSX.Element {
  return (
    <div className="manuscript-chapter-heading">
      <HStack gap={2} align="center">
        <h2 className="manuscript-chapter-title font-bold text-foreground">
          {title || 'Untitled chapter'}
        </h2>
        <IconButton
          className="manuscript-chapter-edit"
          variant="ghost"
          size="sm"
          icon={<Pencil size={14} />}
          label="Edit chapter title and subtitle"
          tooltip="Edit chapter heading"
          onClick={onEdit}
        />
      </HStack>
      {subtitle && <p className="text-lg text-muted-foreground">{subtitle}</p>}
    </div>
  )
}
